import React from 'react';
import { SearchSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/components/SearchSelect';
import { useAppSelector } from 'src/utils/Hooks';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import { createSelector } from '@reduxjs/toolkit';

const getBUsSelector = createSelector(
  (state) => state.segments.businessUnits,
  (businessUnits) => businessUnits.filter((bu) => bu.children.length > 0)
);

export const BusinessUnitSelect = () => {
  const {
    selections: { control }
  } = usePresentationFormContext();
  const businessUnits = useAppSelector(getBUsSelector);

  const selectOptions = businessUnits.map((segment) => ({
    id: segment.id,
    value: segment.id,
    displayName: segment.displayName
  }));

  return (
    <SearchSelect
      name="entityId"
      title="Business Unit Inclusions"
      placeholder="Search or select the business unit you would like to add to your presentation"
      selectOptions={selectOptions}
      control={control}
    />
  );
};
